// NOTE(DS migration, GOTU-3282): layout/text/color primitives + Checkbox migrated to @tempmee/react.
import { motion } from 'framer-motion';
import moment from 'moment';
import { Checkbox } from '@tempmee/react';
import { colors, shadows } from '@tempmee/tailwind';
import { UserSubProfession } from '../../../../enums/UserProfession';
import history from '../../../../browserHistory';
import arrowRightIcon from '../../../../images/arrow_right.svg';
import { getJobStatus } from '../../../Dashboard/ReceiptList/utils';
import { Date } from '../../../Schedule/components/JobCard/components/Date';

// ── inline styles ──────────────────────────────────────────────────────────
// Bespoke legacy markup styles; will be revisited with this component's
// form/action-component DS migration.

const styles = {
  statusText: {
    fontFamily: 'Nunito',
    fontSize: 18,
    textTransform: 'uppercase',
  },
  datetimeText: {
    fontFamily: 'Nunito',
    fontSize: 16,
    textTransform: 'lowercase',
    color: colors.neutral['600'],
  },
  personName: {
    color: colors.neutral['600'],
    fontFamily: 'Nunito',
    fontSize: 18,
    fontWeight: '700',
  },
  professionName: {
    color: colors.neutral['600'],
    fontFamily: 'Nunito',
    fontSize: 16,
  },
};

export const JobCard = ({ job, onSelect, isChecked }) => {
  const { color, label } = getJobStatus(job?.status);

  return (
    <>
      <button
        style={{
          all: 'unset',
          cursor: 'pointer',
          width: 822,
        }}
        type="button"
        onClick={() => history.push(`/dashboard/job/${job.id}`)}
      >
        <motion.div
          key={job.id}
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: colors.shades['0'],
            borderRadius: 8,
            minHeight: 80,
            paddingLeft: 12,
            width: 822,
            boxShadow: 'rgba(0, 0, 0, 0.15) 0px 1px 5px 0px, rgba(0, 0, 0, 0.15) 0px 1px 2px 0px',
          }}
          whileHover={{
            // DS elevation-drop-2dp token (same two layers as the old literal, reordered —
            // visually identical for same-color shadows).
            boxShadow: shadows['elevation-drop-2dp'],
            transition: { duration: 0.15 },
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: 12,
              marginRight: 12,
            }}
          >
            {/* DS Checkbox is the control; stop the toggle from bubbling to the row's
                navigate-on-click (the outer button pushes the job route) */}
            <span
              role="presentation"
              onClick={(event) => event.stopPropagation()}
              style={{ display: 'flex' }}
            >
              <Checkbox checked={isChecked} onChange={() => onSelect(job.id)} />
            </span>
          </div>
          <div
            style={{
              width: 60,
            }}
          >
            <Date
              backgroundColor={color}
              localDate={moment(job.date, 'ddd, MMM D, YYYY').format('YYYY-MM-DD')}
            />
          </div>
          <div
            style={{
              width: 200,
              marginLeft: 32,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <span style={styles.professionName}>
              {UserSubProfession.getName(job?.subProfession) ?? job?.professionName}
            </span>
          </div>

          <div
            style={{
              width: 160,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <span style={{ ...styles.datetimeText }}>{`${job.startTime} - ${job.endTime}`}</span>
          </div>
          <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
            <span style={{ ...styles.statusText, color }}>{label}</span>
          </div>
          <div style={{ width: 48, marginRight: 24, display: 'flex', justifyContent: 'center' }}>
            <img alt="arrow-right" src={arrowRightIcon} />
          </div>
        </motion.div>
      </button>
    </>
  );
};
